<template>
  <v-row justify="center">
    <v-dialog
      v-model="shower"
      scrollable
      max-width="880"
      height="50"
      persistent
    >
      <v-card class="rounded-lg" max-height="600">
        <v-card-title>
          ข้อตกลงและเงื่อนไขการให้บริการ Consent Management Platform
          <v-spacer></v-spacer>
          <v-icon @click="fn_close">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pl-10 pr-10 pt-6 black--text">
          <div class="pb-3">
            <b>Consent Management Platform: CMP</b>
            เป็นแพลตฟอร์มที่ถูกสร้างขึ้นเพื่อให้บริการเกี่ยวกับการจัดการเอกสารนโยบายขององค์กร
            การสร้างเอกสารขอความยินยอม
            ช่องทางการร้องขอแก้ไขเปลี่ยนแปลงความยินยอมที่ผู้ใช้งานเคยให้แก่ผู้ร้องขอคำยินยอมต่อหน่วยงานนั้น
            ๆ
          </div>
          <div class="pb-3">
            การตกลงสมัครใช้งานระบบ Consent Management Platform : CMP
            ถือว่าผู้ใช้บริการได้อ่านและทำความเข้าใจข้อตกลงและเงื่อนไข
            (ซึ่งต่อไปจะเรียกว่า “ข้อตกลงและเงื่อนไข”) โดยละเอียดแล้ว
            และผู้ใช้บริการยอมรับข้อตกลงและเงื่อนไขทุกประการ
          </div>
          <div class="pb-7">
            ทั้งนี้ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) (“บริษัทฯ”)
            ขอสงวนสิทธิ์ในการปรับเปลี่ยนเงื่อนไขของข้อตกลงและเงื่อนไขฉบับนี้ได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            โดยผู้ใช้บริการยอมรับการแจ้งเตือนหรือแจ้งการเปลี่ยนแปลงผ่านอีเมล
            และผู้ใช้บริการตกลงยอมรับข้อผูกพันใด ๆ
            ที่เกิดจากการเปลี่ยนแปลงข้อตกลงและเงื่อนไขฉบับนี้หลังจากมีการแจ้งเตือนดังกล่าวเป็นเวลา
            24 ชั่วโมง
          </div>
          <div class="pb-3"><b>1. การดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล</b></div>
          <div class="pb-3">1.1 “<b>ข้อมูลส่วนบุคคล</b>” หมายความรวมถึง</div>
          <div class="pb-3">ก. ข้อมูลส่วนตัว ได้แก่ ชื่อ นามสกุล</div>
          <div class="pb-3">
            ข. ข้อมูลการติดต่อ ได้แก่ ที่อยู่ หมายเลขโทรศัพท์ อีเมล บัญชี ONE ID
          </div>
          <div class="pb-3">
            1.2 วัตถุประสงค์ของการเก็บรวบรวม ใช้ เปิดเผย ข้อมูลส่วนบุคคล
          </div>
          <div class="pb-3">
            ก. เพื่อใช้สำหรับการสมัครสมาชิกของระบบ CMP (โดยบริษัท
            อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน))
          </div>
          <div class="pb-3">
            ข. เพื่อเป็นข้อมูลในการเข้าใช้บริการระบบ CMP
            ในการการจัดการเอกสารนโยบายขององค์กร การสร้างเอกสารขอความยินยอม
            รวมถึงการตรวจสอบรายงานต่าง ๆ ที่เกี่ยวข้องกับการใช้บริการ
          </div>
          <div class="pb-3">
            1.3 เงื่อนไขอื่น ๆ ที่เกี่ยวข้องกับการประมวลผลข้อมูลส่วนบุคคล
          </div>
          <div class="pb-3">
            ก. บริษัทฯ จะเก็บรวบรวม ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการเพื่อวัตถุประสงค์ตามข้อ 1.2
            เท่านั้น
          </div>
          <div class="pb-3">
            ข. บริษัทฯ จะดูแลไม่ให้ผู้ปฏิบัติงานของบริษัทฯ เปิดเผย แสดง
            หรือทำให้ปรากฏในลักษณะอื่นใดซึ่งข้อมูลส่วนบุคคลของผู้ใช้บริการต่อบุคคลภายนอก
            เว้นแต่จะเป็นไปตามเงื่อนไขภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล
          </div>
          <div class="pb-3">
            ค.บริษัทฯ
            กำหนดให้มีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมและสอดคล้องกับการรักษาความลับของข้อมูลส่วนบุคคล
          </div>

          <div class="pb-3">
            ง.ผู้ใช้บริการสามารถใช้สิทธิในความเป็นส่วนตัวของข้อมูลส่วนบุคคลได้ตามเงื่อนไขภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล
            โดยแจ้งความประสงค์มาที่ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)
          </div>
          <div class="pb-3">
            1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT
            ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ เขตห้วยขวาง กรุงเทพมหานคร 10310
            หมายเลขโทรศัพท์ 02 257 7000
          </div>
          <div class="pb-3">
            จ. บริษัทฯ จะเก็บ ใช้
            และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการตราบเท่าที่จำเป็น
          </div>
          <div class="pb-3"><b> 2. การใช้บริการระบบ CMP</b></div>
          <div class="pb-3">
            2.1 ระบบ CMP เป็นเครื่องมือในการ
            บริหารจัดการการนโยบายและข้อตกลงความยินยอม
            ที่ให้บริการในรูปแบบเว็บแอพพลิเคชั่น และมีการแจ้งเตือนผ่าน
            แอพพลิเคชั่น One Chat
            โดยจำกัดการใช้งานตามข้อตกลงที่ผู้ใช้บริการตกลงใช้บริการกับ บริษัทฯ
          </div>

          <div class="pb-3">
            2.2 ผู้ใช้บริการจะต้องเข้ามาสร้างแผนผังขององค์กรผ่านระบบ one.th
            ซึ่งจะต้องสมัครเข้าใช้งาน ONE ID ในการเข้าสู่ระบบดังกล่าว
            เพื่อเพิ่มตำแหน่งอย่างน้อย 2 อย่างได้ แก่
          </div>
          <div class="pb-3">
            1. “<b>CMP Creator</b> ” มีหน้าที่ในการสร้างนโยบายหรือเอกสารความยินยอม
          </div>
          <div class="pb-3">
            2. “<b>CMP Approval</b>”
            มีหน้าที่ในการสร้างหรืออนุมัตินโยบายหรือเอกสารความยินยอม
          </div>
          <div class="pb-3">
            2.3 การเข้าใช้งานระบบสามารถเข้าใช้งานผ่านทาง OneID
            ซึ่งสามารถเข้าใช้งานระบบตามที่ บริษัทฯ กำหนดเท่านั้น การละเมิด
            หรือพยายามเข้าสู่ระบบโดยมิชอบ ซึ่งความพยายามที่จะกระทำการใด ๆ
            ดังกล่าวนั้นถือเป็นการกระทำความผิดตามที่กฎหมายกำหนด
            ทางบริษัทฯสามารถยกเลิกการให้บริการ
            ระงับบัญชีผู้ใช้งานได้ทันทีโดยมิต้องบอกกล่าว
          </div>
          <div class="pb-3">
            2.4 ระบบ CMP จะประมวลข้อมูลส่วนบุคคลของผู้ใช้บริการ เท่าที่จำเป็น
            และเป็นไปตามวัตถุประสงค์ในการใช้งานผ่านระบบ CMP เท่านั้น
          </div>
          <div class="pb-3">
            2.5 ผู้ใช้บริการสามารถบริหารจัดการ สร้างบัญชีผู้ใช้งาน กำหนดสิทธิ
            สร้างนโยบาย สร้างเอกสารข้อตกลงความยินยอม
            บริหารจัดการคำร้องที่มีการยื่นผ่านระบบ
            รวมถึงดูแบบรายงานการให้ความยินยอมผ่านระบบได้
          </div>
          <div class="pb-3">
            2.6 ผู้ใช้บริการสามารถเชื่อมต่อบริการของผู้ใช้บริการผ่าน Script หรือ
            API ของระบบ CMP
            เพื่อดึงนโยบายหรือเอกสารความยินยอมไปขึ้นบนเว็ปไซต์ของผู้ใช้บริการได้
          </div>
          <div class="pb-3">
            2.7
            ผู้ใช้บริการสามารถส่งเอกสารความยินยอมกับเจ้าของข้อมูลส่วนบุคคลผ่านระบบ
            CMP โดยแบ่งเป็น เจ้าของข้อมูลส่วนบุคคลที่มี ONE ID และอีเมล
            ผ่านช่องทางในระบบ
          </div>
          <div class="pb-3">
            2.8 ผู้ใช้บริการ จะต้องปฏิบัติตามเงื่อนไขของระบบ CMP
            และเว็บไซต์ผู้ใช้บริการจะต้องไม่มีวัตถุประสงค์อันเป็นสิ่งที่ผิดกฎหมายหรือต้องห้ามตามเงื่อนไข
            และข้อกำหนดการใช้งานเหล่านี้ ผู้ใช้บริการจะไม่ใช้ระบบ CMP
            และเว็บไซต์ ในลักษณะใด ๆ ก็ตามซึ่งสามารถทำให้เกิดความเสียหาย
            ทำให้ไร้ซึ่งความสามารถ หรือทำให้ระบบ CMP
            และเว็บไซต์หรือเครือข่ายที่เชื่อมต่อ กับระบบ CMP
            และเว็บไซต์ต้องเสียหาย หรือทำให้เกิดการรบกวนการใช้งานระบบ CMP
            และเว็บไซต์ของบุคคลอื่นใด ผู้ใช้บริการจะต้องไม่พยายามเข้าสู่ระบบ CMP
            และเว็บไซต์โดยปราศจากอำนาจไม่ว่าด้วยวิธีการเจาะฐานข้อมูล (hacking)
            ทำลายรหัสลับส่วนตัว (password mining) หรือวิธีการอื่นใด
          </div>
          <div class="pb-3">
            2.9 ผู้ใช้บริการจะไม่โอนลิขสิทธิ์ใด ๆ ของตนทั้งหมดหรือบางส่วน
            ตามข้อตกลงและเงื่อนไขการใช้บริการระบบ Consent Management Platform
            ให้แก่บุคคลอื่น
          </div>
          <div class="pb-3"><b>3. ค่าบริการและค่าธรรมเนียมต่าง ๆ</b></div>
          <div class="pb-3">
            3.1 ผู้ใช้บริการตกลงชำระค่าบริการทั้งหมดให้แก่บริษัทฯ
            ตามอัตราค่าบริการที่ บริษัทฯ กำหนด และตามวิธีการที่ บริษัทฯ
            แจ้งประกาศไว้ในใบแจ้งรายการใช้บริการ ในจดหมาย
            หรือในข่าวสารที่ส่งไปถึงผู้ใช้บริการ
          </div>
          <div class="pb-3">
            3.2 ผู้ใช้บริการสามารถขอทราบอัตราค่าใช้บริการ ได้ที่สำนักงาน
            เว็บไซต์ หรือโทรศัพท์ผ่านศูนย์บริการลูกค้าสัมพันธ์ของบริษัทฯ
          </div>
          <div class="pb-3">
            3.3 บริษัทฯ
            อาจเรียกเก็บค่าบริการในอัตราที่ต่ำกว่าที่กำหนดไว้ตามรายการส่งเสริมการ
            ขายและการใช้บริการที่กำหนดขึ้นเป็นคราว ๆ
          </div>
          <div class="pb-3">
            <b
              >4. เครื่องหมายการค้า เครื่องหมายบริการ ลิขสิทธิ์
              และสิทธิในทรัพย์สินทางปัญญาอื่นๆ</b
            >
            ข้อมูลที่กำหนดหรือแสดงอยู่ในระบบ CMP เป็นทรัพย์สินของบริษัทฯ
            โดยหมายความรวมถึง เครื่องหมายการค้า เครื่องหมายบริการ ชื่อทางการค้า
            และสัญลักษณ์ทั้งหมดที่อ้างอิงหรือกำหนดอยู่บนระบบ CMP และเว็บไซต์
            โดยไม่จำต้องคำนึงถึงว่าเครื่องหมายการค้า เครื่องหมายบริการ
            และสัญลักษณ์ดังกล่าว ได้รับการจดทะเบียนแล้วหรือไม่ (ซึ่งรวมเรียกว่า
            "เครื่องหมายการค้า") บริษัทฯ
            ไม่อนุญาตหรือให้สิทธิในการใช้ข้อมูลและเครื่องหมายการค้าใด ๆ
            ที่กล่าวข้างต้น รวมถึงไม่อนุญาตให้กระทำการใด ๆ อันเป็นการเปลี่ยนแปลง
            แก้ไข ทำใหม่ ทำซ้ำ ดาวน์โหลด ส่งผ่าน (ไม่ว่าในรูปแบบใด ๆ
            หรือโดยวิธีการใด ๆ) หรือใช้ในลักษณะใด ๆ
            ก็ตามเพื่อวัตถุประสงค์ในทางการค้า
            เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากบริษัทฯ
          </div>
          <div class="pb-3">
            <b
              >5. การบอกเลิกข้อตกลงและเงื่อนไข ข้อจำกัดในการเข้าสู่ข้อมูล
              และข้อห้ามการใช้งาน</b
            >
          </div>
          <div class="pb-3">
            ในกรณีที่บริษัทฯ
            เห็นว่าข้อใดข้อหนึ่งดังต่อไปนี้เกิดขึ้นหรืออาจจะเกิดขึ้นกับผู้ใช้บริการ
            บริษัทฯ
            สามารถใช้ดุลพินิจแต่เพียงผู้เดียวในการบอกเลิกข้อตกลงและเงื่อนไขนี้
            หรือการยกเลิกการให้เข้าสู่ข้อมูลไม่ว่าบางส่วนหรือทั้งหมดของ ระบบ
            CMPรวมทั้งบริการที่เกี่ยวข้องในส่วนใด ๆ ของบริษัทฯ
            โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า โดยบริษัทฯ
            ไม่มีหน้าที่รับผิดชอบต่อความเสียหายที่เกิดขึ้นแก่ผู้ใช้บริการจากการบอกเลิกข้อตกลงและเงื่อนไขดังกล่าว
          </div>
          <div class="pb-3">
            (1) ในกรณีที่ผู้ใช้บริการใช้งาน ระบบ CMP
            สำหรับวัตถุประสงค์ที่ไม่ชอบด้วยกฎหมาย
          </div>

          <div class="pb-3">
            (2) ในกรณีที่บริษัทฯ เชื่อว่ามีการขาดความน่าเชื่อถือของผู้ใช้บริการ
          </div>
          <div class="pb-3">
            (3) ในกรณีที่ผู้ใช้บริการไม่เข้าสู่บัญชีของตนภายในระยะเวลาหนึ่ง
            ตามเงื่อนไขที่บริษัทฯ กำหนด
          </div>
          <div class="pb-3">
            (4) ในกรณีที่ผู้ใช้บริการได้ดำเนินการที่บริษัทฯ เห็นว่าไม่เหมาะสม
          </div>
          <div class="pb-3"><b>6. ข้อจำกัดความรับผิด</b></div>
          <div class="pb-3">
            6.1. ผู้ใช้บริการรับทราบว่าการใช้บริการของบริษัทฯ
            ไม่ได้ทำให้ผู้ใช้บริการเป็นเจ้าของสิทธิในบัญชีผู้ใช้งานหรือมีผลประโยชน์ในทรัพย์สินใด
            ๆ ทั้งนี้
            ผู้ใช้บริการรับทราบว่าความเป็นเจ้าของสิทธิในบัญชีผู้ใช้งานเป็นของบริษัทฯ
          </div>
          <div class="pb-3">
            6.2. เมื่อผู้ใช้งานได้ลงทะเบียนเพื่อขอใช้บริการ ระบบ CMP แล้ว ระบบ
            CMP
            จะทำการเก็บรักษาข้อมูลสำหรับการเข้าใช้งานไว้โดยไม่เปิดเผยต่อผู้อื่นหรือเปิดเผยต่อสาธารณะ
            หากข้อมูลดังกล่าวถูกเปิดเผยจากการกระทำของผู้ใช้บริการไม่ว่าโดยทางตรงหรือทางอ้อม
            บริษัทฯ จะไม่รับผิดชอบต่อการกระทำนั้น ๆ
          </div>
          <div class="pb-3">
            6.3. หลังจากบริษัทฯ ให้สิทธิการเข้าใช้งาน ระบบ CMP แล้ว
            จะถือว่าบัญชีนั้นเป็นสิทธิของผู้ใช้บริการในการเก็บ เปลี่ยนแปลง
            และเข้าในงาน ระบบ CMP โดยบริษัทฯ จะไม่เข้าไปดำเนินการใด ๆ
            หากเกิดการสูญหายของข้อมูล และบริษัทฯ
            ตรวจสอบแล้วพบว่าเป็นการดำเนินการของผู้ใช้บริการเอง บริษัทฯ
            จะไม่รับผิดชอบต่อการกระทำนั้น ๆ
          </div>
          <div class="pb-3">
            6.4. การเข้าใช้งานจะต้องทำการเข้าใช้ผ่านทางช่องทางปกติเท่านั้น
            หากบริษัทฯ ตรวจพบว่ามีการละเมิดหรือพยายามเข้าสู่ระบบโดยมิชอบ บริษัทฯ
            สามารถยกเลิกการให้บริการ และ/หรือ ระงับบัญชีผู้ใช้งานได้ ทั้งนี้
            หากการกระทำดังกล่าวข้างต้นก่อให้เกิดความเสียหายต่อ ระบบ CMP
            ผู้ใช้บริการจะต้องรับผิดชอบในความเสียหายต่อบริษัทฯ
            ตามมูลค่าความเสียหายที่เกิดขึ้นจริง
          </div>
          <div class="pb-3">
            6.5 ผู้ใช้บริการต้องไม่กระทำการใด ๆ
            อันเป็นเหตุให้เกิดความเสียหายต่อบุคคลภายนอก หรือไม่กระทำการใด ๆ
            อันเป็นความผิดต่อพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์
            พ.ศ. 2560 หรือกฎหมายอื่นใด หากบริษัทฯ
            ตรวจพบว่ามีการกระทำหรืองดเว้นการกระทำใดดังกล่าวข้างต้น บริษัทฯ
            สามารถยกเลิกการให้บริการ และ/หรือ ระงับบัญชีผู้ใช้งานได้
            และหากการกระทำดังกล่าวข้างต้นก่อให้เกิดความเสียหายต่อ ระบบ CMP
            ผู้ใช้บริการจะต้องรับผิดชอบในความเสียหายต่อบริษัทฯ
            ตามมูลค่าความเสียหายที่เกิดขึ้นจริง
          </div>
          <div class="pb-3">
            6.6.บริษัทฯ
            ไม่ได้ให้คำรับรองหรือรับประกันโดยชัดแจ้งหรือโดยปริยายแต่อย่างใด
            เกี่ยวกับความเหมาะสม ความน่าเชื่อถือ ความมีอยู่และใช้งานได้ทันกาล
            ทันเวลา การไม่มีไวรัสหรือสิ่งอื่นใดที่เป็นอันตราย
            รวมทั้งความถูกต้องของข้อมูล ซอฟต์แวร์ สินค้าและรูปแบบแผนผังใด ๆ
            ที่เกี่ยวข้องที่ปรากฏอยู่บน ระบบ CMP ทั้งนี้
            ไม่ว่าจะเพื่อวัตถุประสงค์ใด ๆ ก็ตาม
          </div>
          <div class="pb-3">
            บริษัทฯ
            ไม่มีความรับผิดและจะไม่รับผิดสำหรับความสูญเสียหรือความเสียหายใดๆ
            ที่เกิดขึ้นไม่ว่าจะโดยตรงหรือโดยอ้อม
            (รวมทั้งความสูญเสียหรือความเสียหายกรณีพิเศษ) จากการใช้ ระบบ CMP
            โดยผู้ใช้บริการ
          </div>
          <div class="pb-3"><b>7. การรักษาข้อมูลความลับ</b></div>
          <div class="pb-3">
            บริษัทฯ
            ตกลงที่จะดูแลรักษาข้อมูลความลับของผู้ใช้บริการเพื่อให้เป็นความลับ
            โดยจะไม่เปิดเผยข้อมูลของผู้ใช้บริการให้บุคคลใดทราบ
            เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรจากผู้ใช้บริการ และ/หรือ
            เป็นการขอข้อมูลตามที่กฎหมายกำหนด
          </div>
          <div class="pb-3"><b> 8. ช่องทางการติดต่อ</b></div>
          <div class="pb-3">
            บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน) 1768 อาคารไทยซัมมิท
            ทาวเวอร์ ชั้น 10-12 และชั้น IT ถนนเพชรบุรีตัดใหม่ แขวงบางกะปิ
            เขตห้วยขวาง กรุงเทพมหานคร 10310 <br />
            หมายเลขโทรศัพท์ : 02 257 7000 <br />
            Email:
            <a
              style="text-decoration: none"
              href="https://mail.one.th/mail?view=compose&to=mailto%3ADigitize%40inet.co.th"
              >Digitize@inet.co.th
            </a>
            <br />
            Website:
            <a style="text-decoration: none" href="https://www.inet.co.th/"
              >www.inet.co.th
            </a>
          </div>
          <div class="pb-3"><b> 9. กฎหมายที่ใช้บังคับ</b></div>
          <div class="pb-3">
            การตีความและการบังคับตามข้อตกลงและเงื่อนไขฉบับนี้ให้เป็นไปตามกฎหมายไทย
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ['show'],
  data: function () {
    return {}
  },
  created () {},
  computed: {
    shower: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.$emit('closeDialogTerm')
        }
      }
    }
  },
  watch: {},
  methods: {
    fn_close () {
      this.$emit('closeDialogTerm')
    }
  }
}
</script>
<style scoped>
.noteStlye {
  width: 300px;
  word-wrap: break-word;
}
</style>
